import { render } from "./PaymentSuccessStretchGoals.vue?vue&type=template&id=570cdd79"
import script from "./PaymentSuccessStretchGoals.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessStretchGoals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__